import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { UseMutateFunction, useQueryClient } from '@tanstack/react-query'
import { theme } from 'Providers/ThemeProvider'
import { ProductSelection } from 'components'
import { PRODUCTS } from 'constans/queryKeys'
import useToastify from 'hooks/useToastify'
import { useState } from 'react'
import { Button } from 'shared/components'
import { ApiResponseModel } from 'types/common'
import { AllowChangeTemProductModel, ProductModel } from 'types/products'

interface ProductSelectDialogProps {
  open?: boolean
  onClose: () => void
  isPending: boolean
  mutate: UseMutateFunction<
    ApiResponseModel<any>,
    Error,
    AllowChangeTemProductModel,
    unknown
  >
}

const ProductSelectDialog = ({
  open = false,
  onClose,
  mutate,
  isPending = false,
}: ProductSelectDialogProps) => {
  const [disallowProducts, setDisallowProducts] = useState<
    Array<string> | undefined
  >(undefined)

  const { showSuccess, showError } = useToastify()
  const queryClient = useQueryClient()

  const handleClose = (_e: any, r: 'backdropClick' | 'escapeKeyDown') => {
    if (r === 'backdropClick') {
      return
    }
    onClose()
    setDisallowProducts(undefined)
  }

  const handleProductSelect = (arr?: Array<ProductModel>) => {
    if (arr && Array.isArray(arr)) {
      setDisallowProducts(arr.map(x => x.ProductCode))
    } else {
      setDisallowProducts(undefined)
    }
  }

  const onSubmit = () => {
    if (disallowProducts && disallowProducts.length) {
      const lst = disallowProducts.map(x => ({
        productCode: x,
        allowChangeTem: 0,
      }))
      mutate(
        {
          lstProductUpdate: lst,
        },
        {
          onSuccess: d => {
            if (d.ErrorCode === 1) {
              showError('Đã xảy ra lỗi,vui lòng thử lại sau!')
              return
            }
            onClose()
            queryClient.invalidateQueries({
              queryKey: [PRODUCTS],
            })
            setDisallowProducts(undefined)
            showSuccess(
              'Cập nhật thành công, vui lòng xem lại danh sách sản phẩm!'
            )
          },
          onError: () => {
            showError('Đã xảy ra lỗi,vui lòng thử lại sau!')
          },
        }
      )
    }
  }

  return (
    <Dialog
      sx={{
        borderRadius: theme.spacing(2),
      }}
      open={open}
      onClose={handleClose}
      maxWidth="lg"
    >
      <DialogTitle>Chọn sản phẩm không cho phép tích tem</DialogTitle>
      <DialogContent>
        <ProductSelection multiple onChange={handleProductSelect} />
      </DialogContent>
      <DialogActions
        sx={{
          p: 2,
        }}
      >
        <Button
          color="inherit"
          onClick={() => {
            onClose()
            setDisallowProducts(undefined)
          }}
        >
          Hủy bỏ
        </Button>
        <Button
          loading={isPending}
          onClick={onSubmit}
          disabled={!disallowProducts || !disallowProducts.length || isPending}
        >
          Áp dụng
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ProductSelectDialog
